export default __webpack_public_path__ + "static/Totoro-6a7aec5aca79ddcb275bf78c81d8affa.png";